import React, { useState } from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { X } from "lucide-react";
import { useTranslation } from "react-i18next";

interface FavoriteBrandsProps {
  brands: string[];
  onBrandsChange: (brands: string[]) => void;
}

const FavoriteBrands: React.FC<FavoriteBrandsProps> = ({ brands, onBrandsChange }) => {
  const [inputValue, setInputValue] = useState("");
  const { t } = useTranslation();

  const handleAddBrand = () => {
    if (inputValue && !brands.includes(inputValue)) {
      onBrandsChange([...brands, inputValue]);
    }
    setInputValue("");
  };

  const handleRemoveBrand = (brandToRemove: string) => {
    onBrandsChange(brands.filter((brand) => brand !== brandToRemove));
  };

  return (
    <div className="space-y-4">
      <Label>{t("profile.favoriteBrands")}</Label>
      <div className="flex flex-wrap gap-2 mb-2">
        {brands.map((brand) => (
          <div
            key={brand}
            className="inline-flex items-center px-3 py-1 bg-secondary text-secondary-foreground rounded-full text-sm"
          >
            {brand}
            <button
              onClick={() => handleRemoveBrand(brand)}
              className="ml-2 hover:text-destructive focus:outline-none"
              aria-label={`Remove ${brand}`}
            >
              <X className="h-3 w-3" />
            </button>
          </div>
        ))}
      </div>
      <Input
        type="text"
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
        onKeyDown={(e) => e.key === "Enter" && (e.preventDefault(), handleAddBrand())}
        placeholder={t("profile.addBrand")}
        className="max-w-sm"
      />
    </div>
  );
};

export default FavoriteBrands;